import React from 'react'

const IconFullScreenOn = ({fill}) => (
  <svg data-testid='icon_fullscreen_on' xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 25.422 25.422">
    <g id="icon_fullscreen_on" transform="translate(-1855.395 -279)">
      <path fill={fill} id="Icon_awesome-arrow-up" data-name="Icon awesome-arrow-up" d="M1.118,8.6.571,8.049a.589.589,0,0,1,0-.836L5.361,2.42a.589.589,0,0,1,.836,0l4.79,4.79a.589.589,0,0,1,0,.836l-.547.547a.592.592,0,0,1-.846-.01L6.767,5.615V12.7a.59.59,0,0,1-.592.592H5.386a.59.59,0,0,1-.592-.592V5.615L1.964,8.586a.588.588,0,0,1-.846.01Z" transform="translate(1874.513 277.131) rotate(45)" />
      <path fill={fill} id="Icon_awesome-arrow-up-2" data-name="Icon awesome-arrow-up" d="M1.118,8.6.571,8.049a.589.589,0,0,1,0-.836L5.361,2.42a.589.589,0,0,1,.836,0l4.79,4.79a.589.589,0,0,1,0,.836l-.547.547a.592.592,0,0,1-.846-.01L6.767,5.615V12.7a.59.59,0,0,1-.592.592H5.386a.59.59,0,0,1-.592-.592V5.615L1.964,8.586a.588.588,0,0,1-.846.01Z" transform="translate(1861.699 306.291) rotate(-135)" />
    </g>
  </svg>

)

export default IconFullScreenOn